import { FirebaseApp, getApp, getApps, initializeApp } from "firebase/app";
import { Auth, getAuth, signInAnonymously } from "firebase/auth";
import { FirebaseStorage, getStorage } from "firebase/storage";

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  appId: string;
  messagingSenderId?: string;
}

function getFirebaseConfig(): FirebaseConfig | null {
  const apiKey = process.env.GATSBY_FIREBASE_API_KEY;
  const authDomain = process.env.GATSBY_FIREBASE_AUTH_DOMAIN;
  const projectId = process.env.GATSBY_FIREBASE_PROJECT_ID;
  const storageBucket = process.env.GATSBY_FIREBASE_STORAGE_BUCKET;
  const appId = process.env.GATSBY_FIREBASE_APP_ID;
  const messagingSenderId = process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID;

  if (!apiKey || !authDomain || !projectId || !storageBucket || !appId) {
    return null;
  }

  return {
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    appId,
    messagingSenderId,
  };
}

export function getFirebaseApp(): FirebaseApp {
  const config = getFirebaseConfig();
  if (!config) {
    throw new Error("Firebase config is missing. Check GATSBY_FIREBASE_* environment variables.");
  }
  return getApps().length > 0 ? getApp() : initializeApp(config);
}

export function getFirebaseStorageClient(): FirebaseStorage {
  return getStorage(getFirebaseApp());
}

export function getFirebaseAuthClient(): Auth {
  return getAuth(getFirebaseApp());
}

export async function ensureFirebaseAnonymousAuth(): Promise<void> {
  const auth = getFirebaseAuthClient();
  if (auth.currentUser) return;
  await signInAnonymously(auth);
}
